import { BaseNode } from './BaseNode';

export function WatermarkReadNode({ data }: { data: { label: string; key?: string; alias?: string } }) {
  return <BaseNode type="watermark-read" label={data.label} alias={data.alias} lines={[{ text: data.key, mono: true }]} />;
}
